import React from "react";
import AccountLoginPage from "../page/subject/account/AccountLoginPage";
import AccountRegisterPage from "../page/subject/account/AccountRegisterPage";
import AccountPasswordResetPage from "../page/subject/account/AccountPasswordResetPage";
import AccountEditProfilePage from "../page/subject/account/AccountEditProfilePage";
import AccountChangePasswordPage from "../page/subject/account/AccountChangePasswordPage";
import AccountLogOutPage from "../page/subject/account/AccountLogOutPage";
import HomePage from "../page/HomePage";
import AccountPage from "../page/subject/account/AccountPage";
import {getManager} from "../../ts/manager/Manager";
import DataModel from "../../ts/model-factory/basic/data/DataModel";
import LoadingPartial from "../partial/status/LoadingPartial";
import Error404Partial from "../partial/status/Error404Partial";
import AccountLoginRegisterView from "../page/subject/account/partial/AccountLoginRegisterView";
import SimpleTitleArea from "../page/title/SimpleTitleArea";
import DefaultTitleArea from "../page/title/DefaultTitleArea";
import {FactoryID} from "../../ts/model-factory/type-interface/ModelFactoryType";
import RouteChoice from "../../ts/model-factory/basic/route/RouteChoice";
import {IRouteProps} from "../../ts/manager/view/ViewInterface";
import MessagePageListPage from "../page/subject/message/MessagePageListPage";
import FallbackRouteView from "../route/FallbackRouteView";
import MessageEntryPage from "../page/subject/message/MessageEntryPage";
import PostAddPage from "../page/subject/PostAddPage";
import PostListPage from "../page/subject/PostListPage";
import PostLocatePageListPage from "../page/subject/PostLocatePageListPage";
import PostLocateMapPage from "../page/subject/PostLocateMapPage";
import MyProfilePage from "../page/subject/MyProfilePage";
import PostEditPage from "../page/subject/PostEditPage";
import PostPage from "../page/subject/PostPage";
import ActivityPage from "../page/subject/ActivityPage";
import AccountClosePage from "../page/subject/account/AccountClosePage";
import ApplicationsPage from "../page/subject/ApplicationsPage";
import BasicModal from "../component/modal/BasicModal";
import RegisterYourOrganisationModal from "../component/modal/RegisterYourOrganisationModal";

const isSecondaryRoute = (choice:RouteChoice): boolean  =>
{
    if(choice.isFromFirstChildModel || choice.isSecondaryRoute){
        return true;
    }

    return false;

    //const secondaryViewFactoryIDs:FactoryID[] = [];
  //  return secondaryViewFactoryIDs.includes(choice.factoryID);

}

const isModalRoute = (choice:RouteChoice): boolean  =>
{

    return false;
}

const getMainView = (props: IRouteProps): React.JSX.Element|null  =>
{
    const choice = props.choice;
    if(!choice)
    {
        return null;
    }

    if(choice.factoryID === "browse_route"){
        switch (choice.id)
        {
            case "homepage":
                return <HomePage key={props.mainViewKey} {...props}/>
            case "account":
                return <AccountPage key={props.mainViewKey} {...props}/>
            case "organisation":
            case "project":
            case "career":
            case "offer":
                return <PostListPage key={props.mainViewKey} {...props}/>
            case "my_profile":
                return <MyProfilePage key={props.mainViewKey} {...props}/>
            default:
                return null;
        }
    }

    if(choice.factoryID === "my_profile_route"){
        switch (choice.id)
        {
            case "add":
                return <PostAddPage key={props.mainViewKey} {...props}/>
            case "activity":
                return <ActivityPage key={props.mainViewKey} {...props}/>
            case "edit":
                return <PostEditPage key={props.mainViewKey} {...props}/>
            default:
                return null;
        }
    }


    if(choice.factoryID === "sub_page_route"){
        //todo
    }


    if(choice.factoryID === "account_route"){
        switch (choice.id)
        {
            case "login":
                return <AccountLoginPage key={props.mainViewKey} {...props}/>
            case "register":
                return <AccountRegisterPage key={props.mainViewKey} {...props}/>
            case "password_reset":
                return <AccountPasswordResetPage key={props.mainViewKey} {...props}/>
            case "edit_personal_details":
                return <AccountEditProfilePage key={props.mainViewKey} {...props}/>
            case "edit_organisation_profile":
                return <PostEditPage key={props.mainViewKey} {...props}/>
            case "change_password":
                return <AccountChangePasswordPage key={props.mainViewKey} {...props}/>
            case "account_close":
                return <AccountClosePage key={props.mainViewKey} {...props}/>
            case "log_out":
                return <AccountLogOutPage key={props.mainViewKey} {...props}/>
            default:
                return null;
        }
    }

    if(choice.factoryID === "post_route"){
        switch (choice.id)
        {
            case "add":
                return <PostAddPage key={props.mainViewKey} {...props}/>
            case "list":
                return <PostListPage key={props.mainViewKey} {...props}/>
            default:
                break;
        }
        return null;
    }

    if(choice.factoryID === "post_list_route"){
        if(choice.routeIDs.browse_route_id === "my_profile")
        {
            return <PostEditPage key={props.mainViewKey} {...props}/>
        }
        return <PostPage key={props.mainViewKey} {...props}/>
    }

    if(choice.factoryID === "post_entry_route"){
        if(choice.id === "applications"){
            return <ApplicationsPage key={props.mainViewKey} {...props}/>
        }
        return null;
    }

    if(choice.factoryID === "locate_route"){
        switch (choice.id)
        {
            case "page_list":
                return <PostLocatePageListPage key={props.mainViewKey} {...props}/>
            case "map":
                return <PostLocateMapPage key={props.mainViewKey} {...props}/>
            default:
                return null;
        }
    }


    if(choice.factoryID === "message_route"){
        switch (choice.id)
        {
            case "search":
                return <MessagePageListPage key={props.mainViewKey} {...props}/>
            default:
                return null;
        }
    }


    if(choice.factoryID === "message_list_route"){
        return <MessageEntryPage key={props.mainViewKey} {...props}/>
    }

    return null;
}

const getTitleAreaView = (props: IRouteProps):React.JSX.Element => {

    const choice = props.choice;
    if(choice.factoryID === "browse_route"){
        if((choice.id === "homepage") || (choice.id === "my_profile")){
            return <></>;
        }
    }

    return <DefaultTitleArea key={props.titleAreaKey} {...props}/>
}


const getModalView = (props: IRouteProps):React.JSX.Element|null => {
    if(getManager().user.loggedIn() && !getManager().user.organisationID && !getManager().user.didShowRegisterOrganisationPopup){
        if(getManager().navigation.model.routeIDs.browse_route_id !== 'my_profile'){
            return <RegisterYourOrganisationModal routeProps={props} />;
        }
    }
    return null;
}

const getOverrideView = (props: IRouteProps): React.JSX.Element|null  =>
{
    const choice = props.choice;
    for (let i = getManager().navigation.model.levelList.length - 1; i >= 0; i--)
    {
        const level = getManager().navigation.model.levelList[i];
        if (level.factoryID === choice.factoryID && level.choiceID === choice.id)
        {
            for(let derivedModel of level.derivedModels)
            {
                if(derivedModel instanceof DataModel){
                    if((!derivedModel.isPopulated() || derivedModel.populating) && getManager().navigation.routeIsProcessing)
                    {
                        return <LoadingPartial key={props.mainViewKey} {...props}/>;
                    }
                }
            }
        }
    }
    if (getManager().navigation.canNotProceedErrorMessage)
    {
        return <Error404Partial key={props.mainViewKey} {...props}/>
    }

    const requiresLogin = choice.requiresLogin ?? false;

    const loginRequired = requiresLogin && !getManager().user.loggedIn();
    if (loginRequired)
    {
        return <AccountLoginRegisterView key={props.mainViewKey} {...props}/>
    }
    return null;
}

const getDefaultView = (props: IRouteProps): React.JSX.Element  =>
{
    return <FallbackRouteView key={props.mainViewKey} {...props}/>;
}

export default class ViewConfig
{

    getMainView(props: IRouteProps): React.JSX.Element|null
    {
        return getMainView(props)
    }

    getTitleAreaView(props: IRouteProps): React.JSX.Element
    {
        return getTitleAreaView(props)
    }

    getModalView(props: IRouteProps): React.JSX.Element|null
    {
        return getModalView(props)
    }

    getOverrideView(props: IRouteProps): React.JSX.Element|null
    {
        return getOverrideView(props)
    }

    getDefaultView(props: IRouteProps): React.JSX.Element
    {
        return getDefaultView(props)
    }

    getEmptyView(): React.JSX.Element
    {
        return <></>
    }

    isSecondaryRoute = (choice:RouteChoice): boolean  =>
    {
        return isSecondaryRoute(choice);
    }

    isModalRoute = (choice:RouteChoice): boolean  =>
    {
        return isModalRoute(choice);
    }
}